import React from 'react';
import { connect } from 'react-redux';
import { withPusher } from '../contexts/PusherContext';
import AppLayout from '../components/common/appLayout/AppLayout';
import Section from '../components/common/appLayout/Section';
import { DemoGridItems, GridContainer } from '../components/common/appLayout/Grids';
import { Grid } from '@material-ui/core';
// import EditPhoneForm from '../components/phone/phoneSettings/EditPhoneForm';=
import Typography from '../atoms/typography/Typography';
import { RootState } from '../store';

const DemoContainer = () => {
  return (
    <AppLayout>
      <Section>
        <DemoGridItems style={{ marginTop: 25 }} />
      </Section>
      <Section mt={5} style={{ marginBottom: 200 }}>
        <GridContainer style={{ marginTop: 20 }}>
          <Grid item lg={4} md={6} sm={12} xs={12}>
            <Typography variant="h1">h1. Heading </Typography>
            <Typography variant="h2">h2. Heading</Typography>
            <Typography variant="h3">h3. Heading</Typography>
            <Typography variant="h4">h4. Heading</Typography>
            <Typography variant="h5">h5. Heading</Typography>
            <Typography variant="h6">h6. Heading</Typography>
          </Grid>
          <Grid item lg={4} md={6} sm={12} xs={12}>
            <Typography variant="body1">body1. Body</Typography>
            <Typography variant="body2">body2. Body</Typography>
          </Grid>
          <Grid item lg={4} md={4} sm={12} xs={12}>
            <Typography variant="subtitle1">subtitle1. Subtitle</Typography>
            <Typography variant="subtitle2">subtitle2. Subtitle</Typography>
            <Typography variant="caption">caption. Caption</Typography>
            <Typography variant="overline">overline. Overline</Typography>
            <Typography variant="overline" minFontSize={16} maxFontSize={12}>
              overline. Custom Overline
            </Typography>
          </Grid>
        </GridContainer>
      </Section>
    </AppLayout>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    auth: state.auth,
  };
};

// actions to refresh internal/external profile.
const mapDispatchToProps = () => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(withPusher(DemoContainer));
